import { useSelector } from "react-redux";
import axiosInstance from "config/AxiosConfig";
import { BaseResponse } from "domain/payload/response/BaseResponseDto";
import { ProfileDetailResp } from "domain/payload/response/profile/ProfileDetailResp";
import { ProfileUpdateReq } from "domain/payload/request/profile/ProfileUpdateReq";
import { ProfileWalletAmountResp } from "domain/payload/response/profile/ProfileWalletAmountResp";

const ProfileService = () => {
  const { token } = useSelector((state: any) => state.auth);
  
  const getProfile = async (): Promise<BaseResponse<ProfileDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/profile/getProfile`, {
        headers: {
          ...axiosInstance.defaults.headers.head,
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const getWalletAmount = async (): Promise<BaseResponse<ProfileWalletAmountResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/profile/wallet-amount`, {
        headers: {
          ...axiosInstance.defaults.headers.head,
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const updateProfile = async (request: ProfileUpdateReq): Promise<BaseResponse<ProfileDetailResp>> => {
    try {
      const response = await axiosInstance.put(`/v1/legacy/profile/updateProfile`, request, {
        headers: {
          ...axiosInstance.defaults.headers.head,
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const uploadProfilePicture = async (file: File): Promise<BaseResponse<any>> => {
    if (!file) throw new Error("File tidak ditemukan");
    if (file.size && file.size > 500 * 1024) {
      throw new Error("Ukuran file maksimal 500KB");
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axiosInstance.post(`/v1/legacy/profile/upload-profile-picture`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || "Gagal mengunggah foto profil";
    }
  };

  return { getProfile, getWalletAmount, updateProfile, uploadProfilePicture };
};

export default ProfileService;